var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-region-item"},[_c('StatusItem',{staticClass:"status",attrs:{"data-cy":`${_vm.status.code}-status`,"color":_vm.status.color,"label":_vm.status.label}}),(_vm.region)?_c('div',{staticClass:"line"}):_vm._e(),_c('span',{staticClass:"region",attrs:{"data-cy":"region-cell"}},[_vm._v(_vm._s(_vm.region))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }